    import styled, { keyframes } from "styled-components";

// Animações
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Container principal — scroll no próprio painel (cabeçalho sobe ao rolar)
export const MainContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--accent, #6b8f71);
    border-radius: 10px;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  flex: 0 0 auto;
  height: auto;
  min-height: min-content;
  max-width: none;
  padding: 1.25rem 1.25rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  box-sizing: border-box;
  overflow: visible;

  @media screen and (max-width: 768px) {
    padding: 3.5rem 0.75rem 2rem;
  }
`;

/**
 * export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
`;
 */

export const HeaderSection = styled.header`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-shrink: 0;
  margin-bottom: 1rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`;

// Título principal
export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  text-align: left;

  @media (max-width: 768px) {
    font-size: 1.65rem;
  }
`;

/**
 * 
export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 2rem 0 3rem 0;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  text-align: center;
  animation: ${fadeInUp} 0.6s ease-out;
  animation-delay: 0.1s;
  animation-fill-mode: both;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin: 1.5rem 0 2rem 0;
  }
`;
 */


// Subtítulo
export const Subtitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  color: var(--text-heading);
  margin: 0;
  letter-spacing: 0.05em;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const SearchSection = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  position: relative;
  animation: ${fadeInUp} 0.6s ease-out;
  animation-delay: 0.3s;
  animation-fill-mode: both;
  
  // Faz com que todo o componente pareça um único elemento
  backdrop-filter: blur(20px);
  background: var(--input-bg);
  border: 1px solid var(--border-subtle);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
  min-height: 8vh;
  width: 38vw;
  margin: 1% auto;

  &:hover {
    border-color: var(--accent);
    box-shadow: var(--shadow-md);
  }

  &:focus-within {
    border-color: var(--accent);
    box-shadow: var(--shadow-md);
  }

  @media (max-width: 768px) {
    width: 90%;
    flex-direction: column;
    min-height: auto;
  }

  @media (max-width: 480px) {
    width: 95%;
  }
`;

// Agora esses são apenas elementos de layout sem estilo visual próprio
export const SearchContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const SearchBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const SelectStyled = styled.select`
  display: flex;
  outline: none;
  padding: 0.8rem 1rem;
  padding-right: 40px;
  font-size: 14px;
  border: none;
  background-color: transparent;
 color: var(--accent-secondary);
  transition: all 0.3s ease;
  cursor: pointer;
  min-width: 180px;
  height: 100%;
  border-right: 1px solid var(--border-subtle);
  
  // Custom arrow (seta personalizada) — CSS caret (data-URI SVG não resolve CSS vars)
  appearance: none;
  background-image:
    linear-gradient(45deg, transparent 50%, var(--text-heading) 50%),
    linear-gradient(135deg, var(--text-heading) 50%, transparent 50%);
  background-repeat: no-repeat;
  background-position: calc(100% - 18px) calc(50% - 2px), calc(100% - 13px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;

  option {
    background: var(--surface-overlay);
    color: var(--accent-secondary);
    padding: 8px;
  }

  &:focus {
    background-color: var(--input-bg);
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: auto;
    border-right: none;
    border-bottom: 1px solid var(--border-subtle);
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 0.8rem;
    padding-right: 35px;
  }
`;

export const InputStyled = styled.input`
  flex: 1;
  margin-left: 1rem;
  border: none;
  outline: none;
  background: transparent;

  font-size: 14px;
  color: var(--text-primary);

  &::placeholder {
    color: var(--text-secondary);
    opacity: 1;
  }

  &:focus::placeholder {
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }

  @media (max-width: 480px) {
    padding: 0.8rem;
    font-size: 13px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  grid-column: 3; /* Coloca na terceira coluna (direita) */
  margin-right: 2vw;

  @media screen and (max-width: 768px) {
    grid-column: 1;
    justify-content: center;
    order: 2;
  }
`;

/** Botão de navegação — mesmo padrão de ListAreas / Usuários. */
export const StyledButton = styled.button`
  background: ${props => props.secondary ? 'var(--input-bg)' : 'var(--accent-secondary-soft)'};
  border: 2px solid var(--border-default);
  border-radius: 16px;
  color: ${props => props.secondary ? 'var(--text-primary)' : 'var(--text-heading)'};
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;
  white-space: nowrap;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
      ${props => props.secondary
        ? 'var(--surface-glass) 0%, var(--surface-3) 100%'
        : 'var(--accent-secondary-soft) 0%, var(--accent-soft) 100%'}
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 14px;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 14px;
    background: transparent;
    box-shadow: var(--shadow-sm);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-3px);
    border-color: ${props => props.secondary ? 'var(--text-muted)' : 'var(--accent)'};
    color: var(--text-primary);

    &::before {
      opacity: 1;
    }

    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-1px);
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;

export const ActionButton = styled.button`
  position: relative;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  border-radius: 20px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 20vw;
  height: 26vh;
  overflow: hidden;
  
  /* Pseudo-elemento para o gradiente de fundo */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, var(--accent-secondary-soft) 0%, var(--accent-soft) 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 20px;
    z-index: 1;
    box-shadow: inset 0 0 20px var(--accent-soft);
  }
  
  /* Pseudo-elemento para a sombra externa que se move junto */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: transparent;
    box-shadow: var(--shadow-md);
    opacity: 0;
    transition: all 0.4s ease;
    z-index: -1;
    pointer-events: none;
  }
  
  &:hover {
    transform: translateY(-2px);
  }

  &:hover::after {
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(-4px);
  }
  
  &:active::after {
    transform: translateY(-4px);
  }
  
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 140px;
    padding: 1.25rem;
  }
  
  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 120px;
    padding: 1rem;
  }
  
  > * {
    position: relative;
    z-index: 2;
  }
`;


export const SmallActionButton = styled(ActionButton)`
  flex-direction: row;        
  align-items: center;        
  justify-content: center; 
  gap: 0.5rem;                
  padding: 0.8rem 1rem;
  width: 14vw;    
  height: 6vh;        

  @media (max-width: 768px) {
    padding: 0.6rem 0.8rem;
    gap: 0.4rem;
  }

  @media (max-width: 615px) {
    padding: 0.4rem 0.6rem;
    gap: 0.3rem;
    width: auto;
    min-width: 120px;
    height: auto;
    min-height: 40px;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.6rem;
    gap: 0.3rem;
  }
`;

// Ícone do botão
export const ButtonIcon = styled.div`
  font-size: 1.2rem;
  display: flex;              /* 🔥 garante centralização */
  align-items: center;
  justify-content: center;
  filter: drop-shadow(var(--shadow-sm));

  @media (max-width: 615px) {
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;


// Texto do botão
export const ButtonText = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: var(--accent-secondary);
  margin: 0;                  /* 🔥 remove margem que desalinhava */
  line-height: 1.3;
  white-space: nowrap;

  @media (max-width: 615px) {
    font-size: 0.75rem;
    line-height: 1.2;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

export const ProjectListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  flex: 0 0 auto;
  height: auto;
  min-height: min-content;
  max-height: none;
  overflow: visible;
  margin: 0;
  padding: 1rem 0;
  border-radius: 12px;
  background: transparent;
  gap: 1rem;
  box-sizing: border-box;
  
  /* Custom scrollbar vertical azul */
  &::-webkit-scrollbar {
    width: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: var(--info);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: var(--info);
  }
`;